import { createUseEventHook } from '@cms-max/cms-browser-api-client'
import { generateEventMap, useGeneratorArgs } from 'events/lib'

export const useEvent = createUseEventHook(generateEventMap, useGeneratorArgs)
